import { registerPlugin } from '@playkit-js/kaltura-player-js';
import { pluginName, Dummy } from './dummy';

registerPlugin(pluginName, Dummy);

export * from './types';
